import axiosapi from "./axiosAPI";

// Get All PortalSubmissions
export const getAllPortalSubmissions = async (
    setPortalSubmissions,
    setFetcherror,
) => {
    
    
	try{
		const res =await axiosapi.get("/portalSubmissions");
        setPortalSubmissions(res.data.data ? res.data.data : {});

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch PortalSubmissions");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch PortalSubmissions");
		}
		
	}
	
};



// Get One PortalSubmission
export const getOnePortalSubmission = async (
    pkid,
    setFetcherror,  
    setPortalSubmission
    
)=>{
	try{
		const res =await axiosapi.get(`/portalSubmissions/${pkid}`);
        setPortalSubmission(res.data.body);
       
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch PortalSubmission");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch PortalSubmission");
		}
		
	}
	
};



// Get Specific PortalSubmissions
export const getSpecificPortalSubmissions = async (
    setPortalSubmissions,
    setFetcherror,
    setIsLoading,
    setFirst,
    setRows,
    event,
    setTotalCount,
    globalFilter
) => {
    
    const page = ((event?.first)/(event?.rows))+1 || 1
    const limit = (event?.rows) || 10
    
    const options = {
        isprocessed: false,
        isdiscarded: false,
        page: page,
        limit: limit,
        search:globalFilter ? globalFilter : ""
    }
    
	try{
		const res =await axiosapi.post("/specificportalsubmissions",options);
        setPortalSubmissions(res.data.data ? res.data.data : {});
        setTotalCount(res.data.totalCount);
        setIsLoading(false);
        setFirst(event? event?.first:0);
        setRows(event? event?.rows:10)

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch PortalSubmissions");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch PortalSubmissions");
		}
		
	}
	
};

// Change Post Status

export const changePortalSubmissionStatus = async (
    portalSubmissionpkid,
    isprocessed,
    isdiscarded,
    setPortalSubmissions,
    setFetcherror,
    handleAllToasts,
    callback
   
              
        ) => {
            // e.preventDefault();

            if (!(isprocessed ||isdiscarded)) {
                handleAllToasts(2, "Discard or Process Statuses not triggered"); 
                    return;  
                }

            const PushItem = {

                id:portalSubmissionpkid,
                isprocessed:isprocessed,
                isdiscarded:isdiscarded 
                };

            try{
                await axiosapi.patch("/portalsubmissions/", PushItem);
                if (typeof callback === "function") callback(null, "Success");
                handleAllToasts(1, "Submission Discarded Successfully");
                getSpecificPortalSubmissions(setPortalSubmissions, setFetcherror);
            }
            catch(err){
            
                    console.log(`Error: ${err.message}`);
                    setFetcherror("Could Not Update PortalSubmission");
                    handleAllToasts(2, "Could Not Update PortalSubmission");
                    if (typeof callback === "function") callback(new Error("Could Not Update PortalSubmission"), null);
                
            }
            
};


// Create New PortalSubmission
export const createPortalSubmission = async (
    e,
    phone,
    content,
    type,
    setPhone,
    setContent,
    setType,
    setFetcherror,
    handleAllToasts

) => {

    e.preventDefault();

    if (!phone || !content || !type ) {
        handleAllToasts(2, "Either Phone, Content or Type is Missing"); 
            return; 
        }

    const PushItem = {
        phone,
        content,
        type
        };

    try{
        await axiosapi.patch("/portalSubmissions/",PushItem );
        setPhone("");
        setContent("");
        setType("");
        handleAllToasts(1, "PortalSubmission Created Successfully");
    }
    catch(err){
        if(err.response){
            //Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Could Not Create New PortalSubmission");
            handleAllToasts(2, "Could Not update The PortalSubmission");
            
            
        }else{
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Could Not Create New PortalSubmission");
            handleAllToasts(2, "Could Not update The PortalSubmission");
            
        }
        
    }
    
}


// Edit Existing PortalSubmission

export const editPortalSubmission = async (
    portalSubmissionpkid,
    isprocessed,
    isdiscarded,
    setFetcherror,
    handleAllToasts,
    callback
              
        ) => {

            if (!portalSubmissionpkid) {
                handleAllToasts(2, "Cant edit an unassigned submission"); 
                    return;  
                }

    const PushItem = {

        id: portalSubmissionpkid,
        isprocessed,
        isdiscarded
    }
                

            try{
                await axiosapi.patch("/portalSubmissions/",PushItem );
                handleAllToasts(1, "PortalSubmission Updated Successfully");
                if (typeof callback === "function") callback(null, "Success");
            }
            catch(err){
                    setFetcherror("Could Not Update PortalSubmission");
                    handleAllToasts(2, "Could Not Update PortalSubmission");
                    if (typeof callback === "function") callback(new Error("Could Not Update PortalSubmission"), null);
                
            }
            
};



// Delete Existing PortalSubmission.

export const deletePortalSubmission = async (
    portalSubmissionpkid,
    setPortalSubmissions,
    setFetcherror,
    handleAllToasts
)=>{
    try {
        const res = await axiosapi.delete(`/portalSubmissions/${portalSubmissionpkid}`);
        let finalData = res.data.message;
        getAllPortalSubmissions(setPortalSubmissions, setFetcherror);
        handleAllToasts(1, "PortalSubmission Deleted Successfully");
        console.log("Deleted:", finalData);
    }
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
			console.log(err.response.data);
			console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Delete PortalSubmission");
            handleAllToasts(2,"Error: Could Not Delete PortalSubmission");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Delete PortalSubmission");
            handleAllToasts(2,"Error: Could Not Delete PortalSubmission");
		}
		
	}
	
};